import { PriceResponseDTO } from "@requests"
import {ref, Ref} from "vue"

const priceResponse: Ref<PriceResponseDTO | null> = ref(null)

export default priceResponse